export const de = {
    common: {
        invest: "Investieren",
        details: "Details",
        contact: "Kontakt",
        home: "Startseite",
        properties: "Immobilien",
        pricing: "Preise",
        blog: "Blog",
        agents: "Makler",
        contactUs: "Kontaktieren Sie uns",
        login: "Anmelden",
        signup: "Registrieren",
        logout: "Abmelden",
        viewAll: "Alle Immobilien anzeigen",
        readyToInvest: "Bereit zu investieren?",
        getStarted: "Loslegen",
    },
    home: {
        heroTitle: "Finden Sie Ihr Traumhaus",
        heroSubtitle: "Wir helfen Ihnen, die besten Immobilien der Stadt zu finden und Ihre Träume wahr werden zu lassen.",
        whyInvestTitle: "Warum in Immobilien investieren?",
        featuredProperties: "Ausgewählte Immobilien",
        featuredSubtitle: "Von unserem Team handverlesene Immobilien",
        investmentPlansTitle: "Investment-Stufen",
        investmentPlansSubtitle: "Wählen Sie eine Investment-Stufe, die zu Ihrer Strategie passt. Höhere Stufen bieten kürzere Kapitalbindungsfristen.",
        pricingCTA: "Entdecken Sie die perfekte Investment-Stufe für Ihre finanziellen Ziele mit flexiblen Bedingungen und wettbewerbsfähigen Renditen.",
        viewPricing: "Stufen anzeigen",
        exploreProperties: "Möglichkeiten erkunden",
    },
    whyInvest: {
        secure: "Sichere Investition",
        secureDesc: "Verlassen Sie sich auf unsere sicheren Investitionslösungen, Ihre finanzielle Zukunft ist geschützt",
        transparent: "Transparente Plattform",
        transparentDesc: "Erleben Sie das Vertrauen einer transparenten Plattform für Ihre Seelenruhe",
        passive: "Passives Einkommen",
        passiveDesc: "Erkunden Sie Möglichkeiten zur Generierung passiver Einkommensströme",
        support: "Support",
        supportDesc: "Zählen Sie auf unser engagiertes Support-Team für schnelle und zuverlässige Hilfe",
    },
    pricing: {
        starter: "Starter-Plan",
        growth: "Wachstumsplan",
        premium: "Premium-Plan",
        benefits: {
            noFees: "Keine versteckten Gebühren",
            support: "24/7 Kundenbetreuung",
            secure: "Sichere Blockchain-Zahlungen",
            flexible: "Flexible Investitionsbedingungen",
        }
    },
    investment: {
        amount: "Investitionsbetrag",
        period: "Investitionszeitraum",
        confirm: "Zahlung bestätigen",
        minAmountError: "Der Mindestinvestitionsbetrag beträgt 1.000 $",
        confirmTitle: "Investition überprüfen & abschließen",
        awaitingConfirmation: "Warten auf Zahlungsbestätigung",
        statusPending: "Status: Ausstehende Bestätigung",
        viewMyInvestments: "Meine Investitionen anzeigen",
    }
};
